export default function replaceById(objects, newObject) {
  return objects.map(o => (o.id === newObject.id ? newObject : o));
}
